<template>
  <div class="login-box">
    <el-form
      ref="form"
      class="login-container"
      :model="form"
      :rules="rules"
      :label-position="'top'"
    >
      <h3 class="login_title">LiberLive后台管理系统</h3>
      <el-form-item label="用户名" prop="name">
        <el-input v-model="form.name" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>

      <el-button
        @click="submit"
        type="primary"
        style="width: 100%; margin-top: 20px"
        :loading="loading"
        >登 录</el-button
      >
    </el-form>
  </div>
</template>

<script>
// import Mock from "mockjs";
import Cookie from "js-cookie";
export default {
  data() {
    return {
      form: {
        name: "",
        password: "",
      },
      rules: {
        name: [{ required: true, trigger: "blur", message: "请输入用户名" }],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
      loading: false,
    };
  },
  methods: {
    //登录
    submit() {
      //表单校验通过
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 登录请求
          this.$store
            .dispatch("user/login", this.form)
            .then(() => {
              // 打印所有路由信息
              const allRoutes = JSON.parse(localStorage.getItem("menu"));
              //
              const homeRoute = allRoutes.find(
                (item) => item.path === "/" && item.toShow !== 0
              );
              if (homeRoute) {
                window.location.href = "/";
                this.loading = false;
                return;
              }
              // 查找第一个 toShow 为 1 的路由
              const findValidRoute = (routes) =>
                routes.find((item) => item.toShow !== 0);
              const targetRoute = findValidRoute(allRoutes);
              if (targetRoute) {
                const childRoute = targetRoute?.children?.length
                  ? findValidRoute(targetRoute.children)
                  : null;
                // 路由显示且有对应 path
                window.location.href = childRoute?.path || targetRoute?.path;
              } else {
                // 默认跳转逻辑
                window.location.href = "/";
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less">
.login-box {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background-image: url("@/assets/images/bg.png");
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
.login-container {
  display: flex;
  flex-direction: column;
  min-width: 410px;
  // border: 1px solid #eaeaea;
  // margin: 180px auto;
  padding: 40px 30px;
  background-color: #fff;
  border-radius: 15px;
  // box-shadow: 0 0 25px #cac6c6;
  box-sizing: border-box;
  .login_title {
    text-align: center;
    margin-bottom: 30px;
    color: #505458;
    font-size: 24px;
  }
  .el-input {
    // width: 198px;
  }

  .el-form-item__label {
    padding: 0;
  }

  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>
